import axios from "axios";
import { baseUrl, portal } from "../App";
import { apiUrl } from "../api.config";

export default function activityLogSubmission(page_name, msisdn=null) {
  var userAgent = window.navigator.userAgent;
  var sourceUrl = window.location.href;
  const urlParams = new URLSearchParams(window.location.search);
  const cidFromUrl = urlParams.get('qcid');
  var cid = cidFromUrl;
  let storedMsisdn = localStorage.getItem('user_msisdn')
  let userMsisdn = msisdn || (storedMsisdn ? parseInt(storedMsisdn) : null)
  // var cid = cidFromUrl || sessionStorage.getItem('cid');
  axios
    .post(`${apiUrl.activityLog}`, {
      msisdn: userMsisdn,
      page_name: page_name,
      source_url: sourceUrl,
      useragent: userAgent,
      cid:cid,
      company: portal
    })
    .then((response) => {
      // console.log(response);
    })
    .catch((error)=>{
      console.log(error)
    })
}
